var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceRequestsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8619 12.5114V22.4864C29.8619 24.1197 29.0119 25.6364 27.6378 26.4677L19.2228 31.4697C17.8486 32.2864 16.1486 32.2864 14.7603 31.4697L6.34526 26.4677C4.97109 25.651 4.12109 24.1343 4.12109 22.4864V12.5114C4.12109 10.8781 4.97109 9.36135 6.34526 8.5301L14.7603 3.52803C16.1344 2.71136 17.8344 2.71136 19.2228 3.52803L27.6378 8.5301C29.0119 9.36135 29.8619 10.8635 29.8619 12.5114Z",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9981 16.0399C18.8211 16.0399 20.2989 14.5186 20.2989 12.642C20.2989 10.7654 18.8211 9.24414 16.9981 9.24414C15.1751 9.24414 13.6973 10.7654 13.6973 12.642C13.6973 14.5186 15.1751 16.0399 16.9981 16.0399Z",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6654 24.2936C22.6654 21.6686 20.1295 19.5396 16.9987 19.5396C13.8679 19.5396 11.332 21.6686 11.332 24.2936",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceRequestsIcon);
export default __webpack_public_path__ + "static/media/ServiceRequestsIcon.e676f5eb564b7aae57bdfd8d5fa5ccb4.svg";
export { ForwardRef as ReactComponent };